// extracted by mini-css-extract-plugin
export var cdBreakBox = "error-module--cd-break-box--b2286";
export var cdErrorBox = "error-module--cd-error-box--cac14";
export var cdErrorBoxClose = "error-module--cd-error-box-close--5be5e";
export var cdErrorBoxContent = "error-module--cd-error-box-content--d71e7";
export var cdErrorBoxIcon = "error-module--cd-error-box-icon--4e2df";
export var cdErrorWrapper = "error-module--cd-error-wrapper--8bf04";
export var cdSuccessBox = "error-module--cd-success-box--f111a";
export var cdWarningBox = "error-module--cd-warning-box--29fad";
export var isOpen = "error-module--isOpen--064a2";